/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_ExperienceInputs */

const en_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience & Leverage`)
};

const de_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrung & Verhandlungsstärke`)
};

const fr_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expérience et atouts`)
};

const es_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia y ventajas`)
};

const it_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza e leva`)
};

const nl_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ervaring en hefboom`)
};

const pl_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doświadczenie i atuty`)
};

const fi_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokemus ja valtit`)
};

const da_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfaring og forhandlingskort`)
};

const sv_salary_negotiate_experience = /** @type {(inputs: Salary_Negotiate_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfarenhet och förhandlingskort`)
};

/**
* | output |
* | --- |
* | "Experience & Leverage" |
*
* @param {Salary_Negotiate_ExperienceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_experience = /** @type {((inputs?: Salary_Negotiate_ExperienceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_ExperienceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_experience(inputs)
	if (locale === "fr") return fr_salary_negotiate_experience(inputs)
	if (locale === "es") return es_salary_negotiate_experience(inputs)
	if (locale === "it") return it_salary_negotiate_experience(inputs)
	if (locale === "nl") return nl_salary_negotiate_experience(inputs)
	if (locale === "pl") return pl_salary_negotiate_experience(inputs)
	if (locale === "fi") return fi_salary_negotiate_experience(inputs)
	if (locale === "da") return da_salary_negotiate_experience(inputs)
	if (locale === "sv") return sv_salary_negotiate_experience(inputs)
	return en_salary_negotiate_experience(inputs)
});